import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Button } from '@ipc/ipc-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getAssetType } from '../../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { deleteBalanceModificationTransactionsDeleteRequestActionCreator } from '../redux/actions/BalanceModificationTransactionsDeleteActions';

class BalanceModificationTransactionsDeleteDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comments: props.row.row.comments,
      transactionId: props.row.row.id,
    };
    this.confirmEdit = this.confirmEdit.bind(this);
  }

  async confirmEdit() {
    await this.props.deleteBalanceModificationTransactionsDeleteRequestActionCreator(
      this.props.appContext,
      this.state.comments,
      this.state.transactionId,
    );
    this.props.closeDialog();
    await this.props.refreshTransactions();
    this.props.refreshHistories();
  }

  render() {
    return (
      <Dialog onClose={this.props.closeDialog} aria-labelledby="simple-dialog-title" open={this.props.openDialog}>
        <DialogTitle id="simple-dialog-title">Delete Transaction</DialogTitle>
        <div>
          <p style={{ padding: '5px' }}>Are you sure you want to delete these transactions?</p>
        </div>
        <div className="after-box">
          <Button style={{ marginLeft: '25px', marginBottom: '10px' }} onClick={this.props.closeDialog}>Cancel</Button>
          <Button className="primary-button-false" style={{ float: 'right', marginRight: '50px', marginBottom: '10px' }} onClick={this.confirmEdit}>Confirm</Button>
        </div>
      </Dialog>
    );
  }
}

BalanceModificationTransactionsDeleteDialog.propTypes = {
  row: PropTypes.objectOf(PropTypes.shape),
  appContext: PropTypes.objectOf(PropTypes.shape),
  deleteBalanceModificationTransactionsDeleteRequestActionCreator: PropTypes.func,
  openDialog: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
  refreshHistories: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    appContext: getAssetType(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  deleteBalanceModificationTransactionsDeleteRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BalanceModificationTransactionsDeleteDialog);
